/* src/app/components/notification/real-update/real-update.component.scss */
.list-wrapper li label {
  width: 145px;
}
.yellow {
  color: hsl(48, 100%, 67%);
}
.green {
  color: hsl(141, 71%, 48%);
}
.gray {
  color: hsl(0, 0%, 96%);
}
.timeline {
  position: relative;
}
.timeline:before {
  content: " ";
  top: 0px;
  left: 15px;
  bottom: 0px;
  width: 4px;
  background: #ddd;
  position: absolute;
}
.timeline li {
  padding-left: 30px;
  position: relative;
  border-bottom: none;
}
.timeline li span {
  position: absolute;
  width: 16px;
  height: 16px;
  border: 3px solid salmon;
  background-color: #fff;
  border-radius: 100%;
  left: 9px;
  top: 15px;
  z-index: 99;
}
.timeline li:hover {
  background: transparent !important;
}
:host ::ng-deep empty-uname .empty-img {
  width: 40px !important;
  height: 40px;
  font-size: 19px;
}
@media screen and (min-width: 769px) {
  .column.is-one-quarter,
  .column.is-one-quarter-tablet {
    -ms-flex: none;
    flex: none;
    width: 19%;
  }
}
.list-wrapper .list-collapse {
  padding: 15px 10px 10px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list-wrapper .list-collapse span i {
  font-size: 12px;
}
/*# sourceMappingURL=real-update.component.css.map */
